import React, { useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { codeAuth } from 'services/reqres/requests';
import { login } from 'store/auth';
import { useNavigate } from 'react-router-dom';

const Callback = () => {

    const dispatch = useDispatch();
    const authorizationCode = useMemo(() => new URLSearchParams(window.location.search).get('code'), []);
    const navigate = useNavigate();

    useEffect(() => {

        try {

            if (!authorizationCode || authorizationCode === '')  throw new Error('Authorization code not found');
            codeAuth(authorizationCode).then(response => {
                console.log(response, 'response');
                dispatch(login(response));
                navigate('/');
            });
            //
            return;
        } catch(error){
            console.error('Error exchanging authorization code:', error);
        }
        
    }, [authorizationCode, dispatch]);

    return <div>Loading...</div>;
};

export default Callback;